import { useSubscription } from "lib/hooks/subscription";
import { showsIncumbents } from "./relationshipPair";

// Shown with award data or on a trial, the same access the backend checks.
export function useShowsIncumbents(notice: Parameters<typeof showsIncumbents>[0]): boolean {
  const { hasDataTypes, isOnTrial } = useSubscription();
  return showsIncumbents(notice, hasDataTypes("AWARDS") || isOnTrial);
}
